export type Organization = {
  id: number;
  gloplaId: string;
  corporationCode: number;
  gloplaIdName: string;
  corporationAccountName: string;
  corporationOfficialName: string;
  corporationAccountCode: string;
};

const defaultOrganization: Organization = {
  id: 0,
  gloplaId: '',
  corporationCode: 0,
  gloplaIdName: '',
  corporationAccountName: '',
  corporationOfficialName: '',
  corporationAccountCode: '',
};

export const organizationFactory = (organizationAttrs?: {
  [P in keyof Organization]?: Organization[P];
}): Organization => ({ ...defaultOrganization, ...organizationAttrs });
